export const  jobtypeprocess = (formData) => {

    return "Postcard"
}